import { OrderHistoryAdapter } from '@spartacus/order/core';
import { Order, OrderHistoryList } from '@spartacus/order/root';
import { Observable } from 'rxjs';
import { OrdersFilter } from '../../../../model/order-filters.model';

export abstract class CustomUserOrderAdapter extends OrderHistoryAdapter {
  /**
   * Abstract method used to load order history for an user.
   *
   * @param userId The `userId` for given user
   * @param pageSize page size
   * @param currentPage actual page
   * @param sort Sorting method
   * @param ordersFilter orders filters
   */
  abstract loadHistoryFilter(
    userId: string,
    pageSize: number,
    currentPage: number,
    sort: string,
    ordersFilter: OrdersFilter
  ): Observable<OrderHistoryList>;

  abstract loadOrderStatusList(): Observable<any>;

  /**
   * Abstract method used to load order detail.
   *
   * @param userId The `userId` for given user
   * @param orderCode order code
   */
  abstract loadOrderDetail(userId: string, orderCode: string): Observable<Order>;

  /**
   * Abstract method used to set order confirmation checked.
   *
   * @param userId The `userId` for given user
   * @param orderCode order code
   */
  abstract setOrderConfirmationChecked(userId: string, orderCode: string): Observable<Order>;

}
